/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { OfferApiConfiguration } from '../offer-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PomPartnerStylingResponseDto } from '../models/pom-partner-styling-response-dto';

@Injectable({
  providedIn: 'root',
})
export class StylingService extends BaseService {
  constructor(
    config: OfferApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation offerPartnerPartnerCodeStylingGet
   */
  static readonly OfferPartnerPartnerCodeStylingGetPath = '/offer/partner/{partnerCode}/styling';

  /**
   * Fetch partner stlying for FEC
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `offerPartnerPartnerCodeStylingGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  offerPartnerPartnerCodeStylingGet$Response(params: {
    partnerCode: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PomPartnerStylingResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, StylingService.OfferPartnerPartnerCodeStylingGetPath, 'get');
    if (params) {
      rb.path('partnerCode', params.partnerCode, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PomPartnerStylingResponseDto>;
      })
    );
  }

  /**
   * Fetch partner stlying for FEC
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `offerPartnerPartnerCodeStylingGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  offerPartnerPartnerCodeStylingGet(params: {
    partnerCode: string;
  },
  context?: HttpContext

): Observable<PomPartnerStylingResponseDto> {

    return this.offerPartnerPartnerCodeStylingGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<PomPartnerStylingResponseDto>) => r.body as PomPartnerStylingResponseDto)
    );
  }

}
